import PropTypes from 'prop-types';
import React from 'react';

import StorySummary from 'modules/News/components/StorySummary';

require('./MostReadPanel.scss');

export default function MostReadPanel({articles = [], title, showCategory = false}) {
  if (articles.length > 0) {
    return <section className="most-read-list" id="most-read">
      <h3 className="section-title">Most Read {title}</h3>
      { articles.map((article, i) => <StorySummary badge={`${i + 1}`} key={article.article_reference.id} imageType="tipArticle" data={article} metaDataFlags={{category: showCategory, byline: true}}/>) }
    </section>;
  }
  else {
    return null;
  }
}

MostReadPanel.propTypes = {
  showCategory: PropTypes.bool,
  title: PropTypes.string,
  articles: PropTypes.array
};



// WEBPACK FOOTER //
// ./modules/Common/components/MostReadPanel.js